module.exports = __webpack_public_path__ + "static/media/icon-pages.248e5e82.svg";